import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Outlet, NavLink, Navigate, useNavigate, Link } from "react-router-dom";
import BaseLayout from "../../layout/BaseLayout";
import "./forfaits.css";
import PICTURE from "./../../assets/images/img1.jpeg";
import PICTURE2 from "./../../assets/images/img2.jpeg";
import PICTURE3 from "./../../assets/images/img3.jpeg";
import REDIRECTION_BANNER_DESKTOP from "./../../assets/images/redirection_banner_desktop.jpeg";
import REDIRECTION_BANNER_MOBILE from "./../../assets/images/redirection_banner_mobile.jpeg";

// icons
import { getAbonneInfo_allRight } from "../../services/abonne/AbonneRequest";
import CustomLoading from "../custom-page copy/CustomLoading";
import SimpleFooter from "../../components/layout/footer/SimpleFooter";
import { returnImageLink } from "../../utils/ImageLink";
import { isAuthenticated } from "../../utils/AuthGuard";
import { ThreeDots } from "react-loader-spinner";
import { getUrlPublicitaire } from "../../services/publicite/PubRequest";

const AuthGuard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const customerPhoneNumber = sessionStorage.getItem("customer_number")
    ? sessionStorage.getItem("customer_number")
    : "";
  const customerPasswordStat = sessionStorage.getItem(
    "customer_password_statut"
  )
    ? sessionStorage.getItem("customer_password_statut")
    : "";

  useEffect(() => {
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";
    getAbonneInfo_allRight(customerNumber)
      .then((res) => {
        setUser(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  }, []);

  return isAuthenticated() &&
    sessionStorage.getItem("token") &&
    user &&
    user.motdepasseisactif ? (
    <>
      <Outlet context={[customerPhoneNumber, customerPasswordStat]} />
      <SimpleFooter />
    </>
  ) : !isAuthenticated() &&
    sessionStorage.getItem("token") &&
    user &&
    user.motdepasseisactif ? (
    <>
      <Navigate to="/password-access" />
    </>
  ) : sessionStorage.getItem("token") && user && !user.motdepasseisactif ? (
    <>
      {user && !user.motdepasseisactif ? (
        <>{sessionStorage.removeItem("token")}</>
      ) : null}
      <Outlet context={[customerPhoneNumber, customerPasswordStat]} />
      <SimpleFooter />
    </>
  ) : !sessionStorage.getItem("token") && user && user.motdepasseisactif ? (
    <>
      <Navigate to="/password-access" />
    </>
  ) : !sessionStorage.getItem("token") && user && !user.motdepasseisactif ? (
    <>
      <Outlet context={[customerPhoneNumber, customerPasswordStat]} />
      <SimpleFooter />
    </>
  ) : (
    <>
      <Outlet context={[customerPhoneNumber, customerPasswordStat]} />
      <SimpleFooter />
    </>
  );
};

const Forfaits = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showPromo, setShowPromo] = useState(false);
  const [user, setUser] = useState({});
  const [urlPublicitaire, setUrlPublicitaire] = useState(null);
  const [userNotAllow, setUserNotAllow] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [message, setMessage] = useState("");

  const recupererURLPublicitaire = () => {
    getUrlPublicitaire("ACCUEIL")
      .then((res) => {
        setUrlPublicitaire(res.data.donnee ? res.data.donnee : null);
      })
      .catch((err) => err);
  };

  useEffect(() => {
    recupererURLPublicitaire();

    sessionStorage.removeItem("typeAchat");
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";
    getAbonneInfo_allRight(customerNumber)
      .then((res) => {
        setUser(res.data.donnee);
        sessionStorage.setItem("user", JSON.stringify(res.data.donnee));
        if (res.data.donnee.promo) {
          setShowPromo(true);
        } else {
          setShowPromo(false);
        }

        if (
          !sessionStorage.getItem("presence") &&
          sessionStorage.getItem("token")
        ) {
          document.getElementById("btn-alert").click();
          sessionStorage.setItem("presence", true);
        } else if (
          !sessionStorage.getItem("presence") &&
          !sessionStorage.getItem("token")
        ) {
          document.getElementById("btn-alert").click();
        }
      })
      .catch((err) => {
        if (err.response && err.response.data.statut === 1) {
          setUserNotAllow(err.response.data.donnee);
          document.getElementById("alert-modal-not-allow").click();
        } else if (
          err.response &&
          err.response.data.statut === 2 &&
          !sessionStorage.getItem("customer_number")
        ) {
          setMessage(err.response.data.donnee);
          document.getElementById("alert-modal-enter-number").click();
        }
      });
  }, []);

  const findUserInfo = () => {
    setLoading(true);
    getAbonneInfo_allRight(userPhoneNumber)
      .then((res) => {
        sessionStorage.setItem("customer_number", userPhoneNumber);
        sessionStorage.setItem(
          "customer_password_statut",
          res.data.donnee.motdepasseisactif
        );
        setUser(res.data.donnee);
        setLoading(false);
        sessionStorage.setItem("user", JSON.stringify(res.data.donnee));

        if (res.data.donnee.promo) {
          setShowPromo(true);
        } else {
          setShowPromo(false);
        }

        if (
          !isAuthenticated() &&
          sessionStorage.getItem("token") &&
          res.data.donnee.motdepasseisactif
        ) {
          navigate("/password-access");
        } else if (
          !sessionStorage.getItem("token") &&
          res.data.donnee.motdepasseisactif
        ) {
          navigate("/password-access");
        }

        if (
          !sessionStorage.getItem("presence") &&
          sessionStorage.getItem("token")
        ) {
          document.getElementById("btn-alert").click();
          sessionStorage.setItem("presence", true);
        } else if (
          !sessionStorage.getItem("presence") &&
          !sessionStorage.getItem("token")
        ) {
          document.getElementById("btn-alert").click();
        }
        document.getElementById("alert-modal-enter-number").click();
      })
      .catch((err) => {
        setLoading(false);
        document.getElementById("alert-modal-enter-number").click();
        if (err.response && err.response.data.statut === 1) {
          setUserNotAllow(err.response.data.donnee);
          document.getElementById("alert-modal-not-allow").click();
        } else if (
          err.response &&
          err.response.data.statut === 2 &&
          !sessionStorage.getItem("customer_number")
        ) {
          setMessage(err.response.data.donnee);
          document.getElementById("alert-modal-enter-number").click();
        }
      });
  };

  return (
    <BaseLayout>
      <div className="header relative w-full h-fit pb-10 bg-jaune-mtn">
        <div className="z-10 absolute bottom-0 left-0 right-0 bg-gray-mtn w-full">
          <svg
            height="19px"
            viewBox="0 0 1366 19.18"
            preserveAspectRatio="none"
            className="w-full hidden sm:block bg-jaune-mtn"
          >
            <path
              d="M683.1,18.3C386.63,18.3,129.24,10.85,0,0V19.18H1366V0C1236.66,10.84,979.37,18.3,683.1,18.3Z"
              fill="#f2F2f2"
            ></path>
          </svg>
          <svg
            viewBox="0 0 500 40"
            preserveAspectRatio="xMidYMin meet"
            className="w-full block sm:hidden bg-gray-mtn"
          >
            <path d="M0,0 Q250,80 500,0 Z" fill="#ffcc02"></path>
          </svg>
        </div>

        <div className="w-11/12 md:w-10/12 lg:w-10/12 xl:w-9/12 mx-auto pt-10 sm:pt-5">
          <h1 className="w-fit mx-auto text-center font-bold text-lg sm:text-xl md:text-2xl px-4">
            Bienvenue sur le portail internet de MTN
          </h1>

          <div>
            <img
              // src={returnImageLink("ACCUEIL", "TELEPHONE")}
              src={REDIRECTION_BANNER_MOBILE}
              alt="promo mtn"
              className="block sm:hidden w-full mx-auto h-72 object-contain rounded-lg mt-8"
              // onClick={() => urlPublicitaire && window.open(urlPublicitaire, "_blank")}
              onClick={() => window.open("https://mtnone.mtn.ci", "_blank")}
            />
            <img
              // src={returnImageLink("ACCUEIL", "ORDINATEUR")}
              src={REDIRECTION_BANNER_DESKTOP}
              alt="promo mtn"
              className="hidden sm:block w-full mx-auto h-44 sm:h-56 object-contain rounded-lg mt-8"
              // onClick={() => urlPublicitaire && window.open(urlPublicitaire, "_blank")}
              onClick={() => window.open("https://mtnone.mtn.ci", "_blank")}
            />
          </div>

          <div className="menu-forfait mt-8 md:mt-10 flex items-center justify-evenly">
            <NavLink
              className={location.pathname === "/" ? "active" : ""}
              to="/forfaits/acheter"
            >
              <button
                className="text-xs sm:text-sm text-black font-bold hover:text-jaune-mtn hover:bg-black p-2"
                onClick={() =>
                  sessionStorage.setItem("typeAchat", "ACHAT_POUR_SOI")
                }
              >
                <span>Acheter</span> <br /> <span>Forfait</span>
              </button>
            </NavLink>
            {/* <NavLink to="/forfaits/offrir">
              <button className="text-xs sm:text-sm text-black font-bold hover:text-jaune-mtn hover:bg-black p-2">
                <span>Offrir</span> <br /> <span>Forfait</span>
              </button>
            </NavLink> */}
            <NavLink to="/forfaits/emprunter">
              <button
                className="text-xs sm:text-sm flex flex-col items-center justify-center text-black font-bold hover:text-jaune-mtn hover:bg-black p-2"
                onClick={() => sessionStorage.setItem("typeAchat", "EMPRUNT")}
              >
                <span className="text-center px-2">Emprunter</span>{" "}
                <span className="text-center px-2">Forfait</span>
              </button>
            </NavLink>
            {/* <NavLink to="/forfaits/mtn-play">
              <button className="text-xs sm:text-sm  text-black font-bold hover:text-jaune-mtn hover:bg-black py-2 px-0">
                <span className="text-center">MTN</span> <br />{" "}
                <span className="text-center">Play</span>
              </button>
            </NavLink> */}
          </div>
        </div>
      </div>
      <div className="w-full bg-gray-mtn pt-5">
        <div className="w-11/12 xl:w-9/12 mx-auto divider"></div>

        <AuthGuard customer={userPhoneNumber} />

        <label htmlFor="alert-modal" id="btn-alert" className="hidden">
          open modal
        </label>
      </div>

      {/* DEBUT FOOTER */}
      {/* <div className="relative bg-black w-full h-fit pt-24 sm:pt-20 pb-16">
        <div className="w-full absolute top-0 left-0 right-0">
          <svg
            height="19px"
            viewBox="0 0 1366 19.18"
            preserveAspectRatio="none"
            className="w-full hidden sm:block bg-gray-mtn"
          >
            <path
              d="M683.1,18.3C386.63,18.3,129.24,10.85,0,0V19.18H1366V0C1236.66,10.84,979.37,18.3,683.1,18.3Z"
              fill="#000"
            ></path>
          </svg>
          <svg
            viewBox="0 0 500 40"
            preserveAspectRatio="xMidYMin meet"
            className="w-full block sm:hidden bg-black"
          >
            <path d="M0,0 Q250,80 500,0 Z" fill="#f2F2F2"></path>
          </svg>
        </div>

        <div className="footer-menu max-w-7xl w-10/12 md:w-10/12 mx-auto hidden sm:flex flex-col items-center">
          <div className="text-white text-xl flex items-center gap-x-10">
            <h2>Nous retrouver :</h2>
            <FacebookOutlinedIcon sx={{ fontSize: "35px" }} />
            <TwitterIcon sx={{ fontSize: "35px" }} />
            <LinkedInIcon sx={{ fontSize: "35px" }} />
            <YouTubeIcon sx={{ fontSize: "35px" }} />
            <InstagramIcon sx={{ fontSize: "35px" }} />
          </div>
          <div className="w-3/5 text-sm text-stone-600 flex items-center justify-evenly mt-8">
            <p>© 2022 MTN Côte d'Ivoire</p>
            <p>Terms and conditions</p>
            <p>Privacy policy</p>
          </div>
        </div>

        <div className="footer-menu max-w-7xl w-10/12 md:w-10/12 mx-auto flex sm:hidden flex-col items-center">
          <div className="text-white text-xl flex flex-col items-center gap-y-4">
            <h2>Nous retrouver :</h2>
            <div className="w-full flex items-center justify-evenly gap-x-8">
              <FacebookOutlinedIcon sx={{ fontSize: "30px" }} />
              <TwitterIcon sx={{ fontSize: "30px" }} />
              <LinkedInIcon sx={{ fontSize: "30px" }} />
              <YouTubeIcon sx={{ fontSize: "30px" }} />
              <InstagramIcon sx={{ fontSize: "30px" }} />
            </div>
          </div>
          <div className="w-full text-xs text-stone-600 gap-x-5 flex items-center justify-evenly mt-8">
            <p className="text-left">© 2022 MTN Côte d'Ivoire</p>
            <p className="text-center">Terms and conditions</p>
            <p className="text-right">Privacy policy</p>
          </div>
        </div>
      </div> */}
      {/* FIN FOOTER */}

      {/* MODAL ALERT NOTE */}
      <input type="checkbox" id="alert-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box bg-gray-mtn w-11/12 max-w-5xl rounded-md relative">
          <label
            htmlFor="alert-modal"
            className="btn btn-sm btn-circle absolute right-2 top-2"
            onClick={() => sessionStorage.setItem("presence", true)}
          >
            ✕
          </label>
          <h3 className="text-xl text-center font-bold">Note :</h3>
          <p className="py-4 md:px-16 text-center text-red-500">
            Vous êtes sur cette page parce que votre volume internet est
            insuffisant ou épuisé. Le détail de votre compte est disponible au
            bas de la page.
          </p>
        </div>
      </div>

      {/* MODAL ALERT PAS UN UTILISATEUR MTN */}
      <input
        type="checkbox"
        id="alert-modal-not-allow"
        className="modal-toggle"
      />
      <div className="modal">
        <div className="modal-box bg-gray-mtn w-11/12 max-w-5xl rounded-md relative">
          <h3 className="text-xl text-center font-bold">Note :</h3>
          <p className="py-4 md:px-16 text-center text-red-500">
            {userNotAllow}
          </p>
        </div>
      </div>

      {/* MODAL ALERT ENTRER UN NUMERO */}
      <input
        type="checkbox"
        id="alert-modal-enter-number"
        className="modal-toggle"
      />
      <div className="modal">
        <div className="modal-box bg-gray-mtn max-w-xl rounded-md relative">
          <h3 className="text-lg sm:text-xl text-center font-bold">
            {message}
          </h3>
          <div className="py-4">
            <label className="label">
              <span className="label-text">Numéro bénéficiaire</span>
            </label>
            <input
              type="number"
              value={userPhoneNumber}
              onChange={(e) => setUserPhoneNumber(e.target.value)}
              placeholder="Ex: 0572443712"
              className="input input-bordered w-full"
            />
          </div>
          <div className="flex justify-center">
            <button
              className="w-full h-11 rounded-lg bg-jaune-mtn font-bold text-black flex items-center justify-center"
              onClick={findUserInfo}
            >
              {!loading ? (
                "Valider"
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={loading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {showPromo ? (
        <div className="toast" style={{ zIndex: "9999999" }}>
          <div className="alert bg-white shadow-2xl border border-gray-300">
            <div className="relative sm:w-96 flex flex-col items-start">
              <button
                className="btn btn-sm btn-circle absolute -right-1 -top-1"
                onClick={() => setShowPromo(false)}
              >
                ✕
              </button>
              <h2 className="text-left font-bold">Promotion 🎉🥳</h2>
              <p>{user.promo}</p>
            </div>
          </div>
        </div>
      ) : null}
    </BaseLayout>
  );
};

export default Forfaits;
